import { connect } from 'react-redux';

import Select from '@/components/StatisticsTopBar/Select';
import { updateCampaignType } from '@/features/campaignsStatisticsDetailsPage/actions';
import { getCampaignType } from '@/features/campaignsStatisticsDetailsPage/selectors';
import { options } from '@/filters/CampaignType';

const mapStateToProps = state => ({
  items: options,
  value: getCampaignType(state),
});

const mapDispatchToProps = { onChange: updateCampaignType };

export default connect(mapStateToProps, mapDispatchToProps)(Select);
